<script setup>
import { ref } from 'vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import Modal from 'dashboard/components/Modal.vue';
import ModalHeader from 'dashboard/components/ModalHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  imageSrc: {
    type: String,
    default: null,
  },
  aspectRatio: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['close', 'save']);

const cropperRef = ref(null);

const handleClose = () => {
  emit('close');
};

const handleSave = () => {
  if (cropperRef.value) {
    const { canvas } = cropperRef.value.getResult();
    if (canvas) {
      canvas.toBlob(blob => {
        emit('save', blob);
      }, 'image/png');
    }
  }
};
</script>

<template>
  <Modal :show="show" :on-close="handleClose">
    <ModalHeader
      header-title="Recortar Logo"
      header-content="Ajuste o corte da logo para o sistema White Label"
    />
    <div class="p-4">
      <div class="w-full h-64 bg-n-slate-2 flex items-center justify-center">
        <Cropper
          ref="cropperRef"
          :src="imageSrc"
          class="w-full h-full"
          :stencil-props="{
            handlers: {},
            movable: true,
            resizable: true,
            aspectRatio: aspectRatio,
          }"
        />
      </div>
      <div class="flex justify-end gap-2 mt-4">
        <!-- eslint-disable-next-line vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
        <NextButton variant="outline" @click="handleClose">
          Cancelar
        </NextButton>
        <!-- eslint-disable-next-line vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
        <NextButton blue @click="handleSave"> Salvar </NextButton>
      </div>
    </div>
  </Modal>
</template>
